export const API_ROOT = 'api/';
export const AUTH_STORAGE_KEY = 'auth_data';
export const LOCALE = 'sk';
export const OAUTH_CLIENT_ID='planis-client';
export const OAUTH_SECRET='password';



// WEBPACK FOOTER //
// ./client/config.js